import { IGenericTask } from '@interfaces/task/generic/IGenericTask'

interface IMockedTaskResult {
  count: number
  totalCount: number
  values: IGenericTask[]
}

export const mockedTasks: IMockedTaskResult = {
  totalCount: 1,
  count: 1,
  values: [
    {
      jobId: 44015,
      startTime: new Date(),
      duration: 10,
      crewSize: 2,
      needsEquipmentRental: false,
      permitTypeIds: [22],
      permitNeeded: 1,
      operationPostId: 209,
      assignments: [
        {
          description: 'ACUREN TO INSPECT ISO 3121A',
          crewSize: 2,
          assignmentIds: [],
          duration: 10,
          offset: 0,
          taskId: 179084,
          resourceId: 590,
          assigneeIds: [1000190],
          wasDeleted: false,
          resourceDescription: 'Contractor Inspection Services',
          assignees: [],
          id: 269773,
        },
      ],
      jobTaskCount: 4,
      jobName: 'INSP_CL1 Iso 1321A Need Scaffold_April17 AMP.11414971',
      location: 'REFINERY STORAGE',
      permitTypes: [
        {
          description: 'Cold Work',
          isActive: true,
          id: 22,
        },
      ],
      commentCount: 0,
      projectId: 40,
      functionalLocation: 'Refinery Storage Piping',
      notification: '13341434',
      barrierCount: 2,
      potentialBarriers: [],
      status: 'completed',
      isPullAhead: false,
      isReset: false,
      isSplit: false,
      isComplete: true,
      permitStatus: 1,
      sequence: 0,
      sequentialCode: 'AMP.11414971.0030',
      name: 'ACUREN TO INSPECT ISO 3121A',
      code: 'AMP.11414971.0030',
      workOrder: '11414971',
      hasBarrier: true,
      isBreakIn: false,
      equipmentTag: 'BIR-RST-016',
      id: 179084,
    },
  ],
}
